(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wix-perf-measure", [], factory);
	else if(typeof exports === 'object')
		exports["wix-perf-measure"] = factory();
	else
		root["wix-perf-measure"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 